(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const dataContainer = document.querySelector('#sbs-alternatives-data');
    const data = JSON.parse(dataContainer?.textContent || "{}");
    dataContainer?.remove();

    if (!data) return;

    class OOSAlternativesBlock extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.classList.add('sbs-alternatives');
        const blockData = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || "{}");
        if (!blockData?.product) return null;
        const resultsContainer = document.querySelector(`.sbs-alternatives-results[data-product-id="${blockData.product.id}"]`);
        init(this, resultsContainer, {...data, ...blockData});
        this.addEventListener('click', (e) => {
          e.stopPropagation();
        })
      }
    }

    customElements.define('oos-alternatives-block', OOSAlternativesBlock);

    class OOSAlternativesBoostBlock extends HTMLElement {
      constructor() {
        super();

        if (this.dataset.handle) {
          fetch(`/products/${this.dataset.handle}?view=oos-alternatives-boost-block`)
          .then((res) => res.text())
          .then((markup) => {
            if (markup.includes('oos-alternatives-block')) {
              const container = document.createElement('div');
              container.innerHTML = markup;
              const block = container.querySelector('oos-alternatives-block');
              if (block) this.parentElement.insertBefore(block, this);
            }
          }).finally(() => {
            this.remove();
          })
        } else {
          this.remove();
        }
      }
    }

    customElements.define('oos-alternatives-boost-block', OOSAlternativesBoostBlock);
  });


  function init(block, resultsContainer, data) {
    const strings = {
      SIMILAR_NEUTRAL: data.settings.strings.find_similar_neutral || 'Find similar products',
      SIMILAR_FINDING: data.settings.strings.find_similar_finding || 'Finding similar products',
      SIMILAR_FAILED: data.settings.strings.find_similar_failed || 'Couldn\'t find similar products',
      VIEW_PRODUCT: data.settings.strings.view_product || 'View product',
    };

    const searchTypes = {
      GENERAL: 'general',
      VARIANT: 'variant',
    };

    resultsContainer?.setAttribute('style', `--margin-y: ${data.styles.margin_y_results};`);

    const config = {
        selectedVariant: {},
        cachedAlternatives: {},
        showAutomatically: false,
    };
    watchVariantChange();

    function showResults(alternativeCards) {
      if (!resultsContainer) {
        showInPopup(alternativeCards);
      } else {
        resultsContainer.innerHTML = `
          <div class="sbs-slider">
            <div class="sbs-alternatives__cards sbs-slider__slides"></div>
            <div class="sbs-slider__navigation">
              <div class="sbs-slider__navigation-btn sbs-slider__navigation-btn--prev" data-visible="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z" fill="currentColor"/>
                </svg>
              </div>
              <div class="sbs-slider__navigation-btn sbs-slider__navigation-btn--next" data-visible="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z" fill="currentColor"/>
                </svg>
              </div>
              </div>
          </div>
        `;

        const alternativesCardsContainer = resultsContainer.querySelector('.sbs-alternatives__cards');
        alternativeCards.forEach(card => {
            alternativesCardsContainer.appendChild(card);
        });

        initSlider(resultsContainer);
      }
    }

    function showInPopup(alternativeCards) {
        const popup = document.createElement('div');
        popup.classList.add('sbs-alternatives-popup', `sbs-alternatives-popup--desktop-${data.settings.desktop_layout}`);

        popup.innerHTML = `
        <div class="sbs-alternatives-popup__content">
            <div class="sbs-alternatives-popup__header">
                <p class="sbs-alternatives-popup__title">Alternative products</p>
                <button type="button" class="sbs-alternatives-popup__close">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <g id="x">
                      <path d="M52.83,50,96.41,6.41a2,2,0,0,0-2.82-2.82L50,47.17,6.41,3.59A2,2,0,0,0,3.59,6.41L47.17,50,3.59,93.59a2,2,0,1,0,2.82,2.82L50,52.83,93.59,96.41a2,2,0,0,0,2.82-2.82Z" fill="currentColor"></path>
                    </g>
                  </svg>
                </button>
            </div>
            <div class="sbs-alternatives-popup__body">
              ${data.settings.products_list_layout === 'slider' ? '<div class="sbs-slider">' : ''}
                <div
                  class="
                    sbs-alternatives-popup__cards
                    sbs-alternatives-popup__cards--${data.settings.products_list_layout}
                    sbs-alternatives-popup__cards--cols-${data.settings.cols}
                    sbs-alternatives-popup__cards--cols-desktop-popup-${data.settings.cols_desktop_popup}
                    ${data.settings.products_list_layout === 'slider' ? 'sbs-slider__slides' : ''}
                  "
                ></div>
              ${data.settings.products_list_layout === 'slider' ? `
                <div class="sbs-slider__navigation">
                  <div class="sbs-slider__navigation-btn sbs-slider__navigation-btn--prev" data-visible="false">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                      <path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div class="sbs-slider__navigation-btn sbs-slider__navigation-btn--next" data-visible="false">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                      <path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
              </div>
              ` : ''}
            </div>
        </div>
        `;

        const alternativesCardsContainer = popup.querySelector('.sbs-alternatives-popup__cards');
        alternativeCards.forEach(card => {
            alternativesCardsContainer.appendChild(card);
        });

        const closeButton = popup.querySelector('.sbs-alternatives-popup__close');

        popup.addEventListener('click', (e) => {
            if(e.target.contains(popup) || closeButton.contains(e.target)) {
                popup.classList.add('sbs-alternatives-popup--disappearing');
                setTimeout(() => {
                  popup.parentElement.removeChild(popup);
                  document.body.classList.remove('sbs-overlay-active');
                  document.documentElement.classList.remove('sbs-overlay-active');
                }, 250);
            }
        });

        document.body.appendChild(popup);
        document.body.classList.add('sbs-overlay-active');
        document.documentElement.classList.add('sbs-overlay-active');

        initSlider(popup);
    }

    function buildAlternativeCard(alternativeData, searchType) {
      const card = document.createElement("div");
      card.classList.add("sbs-alternative");
      if (data.settings.products_list_layout === 'slider' || resultsContainer) {
        card.classList.add('sbs-slider__slide');
      }

      let selectedAlternativeVariant = searchType === searchTypes.VARIANT ?
        alternativeData.variants.find(
          (variant) => variant.title === config.selectedVariant.title,
        ) : null;

      if (!selectedAlternativeVariant && searchType === searchTypes.VARIANT) {
        let maxMatchingOptions = 0;
        alternativeData.variants.forEach((variant) => {
          const matchingOptions = variant.options.filter((option) => config.selectedVariant.options.includes(option)).length;
          if (matchingOptions > maxMatchingOptions) {
            selectedAlternativeVariant = variant;
            maxMatchingOptions = matchingOptions;
          }
        });
      }

      if (!selectedAlternativeVariant) {
        selectedAlternativeVariant = 
          alternativeData.variants.find((variant) => variant.available) ||
          alternativeData.variants[0];
      }
      
      const featuredImage = selectedAlternativeVariant.featured_image?.src || alternativeData.featured_image;

      card.innerHTML = `
        <a href="${alternativeData.url}" class="sbs-alternative__image">
            ${featuredImage ? `<img src="${featuredImage}" width="200" height="200">` : ""}
        </a>
        <a href="${alternativeData.url}" class="sbs-alternative__title">${alternativeData.title}</a>
        <p class="sbs-alternative__price">${formatMoney(selectedAlternativeVariant.price)}</p>
        <a
          href="${alternativeData.url}"
          class="sbs-alternative__button"
          ${!selectedAlternativeVariant.available ? 'disabled': ''}
          style="
            --sbs-result-btn-bg: ${data.styles.result_btn_bg};
            --sbs-result-btn-fg: ${data.styles.result_btn_fg};
            --sbs-result-btn-border-radius: ${data.styles.result_btn_border_radius};
          "
        >
            <span>${strings.VIEW_PRODUCT}</span>
            <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.457 15.457l-1.414-1.414L9.836 8.25 4.043 2.457l1.414-1.414 7.207 7.207-7.207 7.207z" fill="currentColor"/>
            </svg>
        </a>
      `;

      return card;
    }

    async function showAlternatives(alternatives, searchType) {
      const alternativesData = await Promise.all(
        alternatives.map((alternative) => {
          if (alternative === data.product.handle) return null;
          return fetch(`/products/${alternative}.js`).then((res) => {
            if (res.status === 200) {
              return res.json();
            } else {
              return null;
            }
          });
        }),
      );

      const validAlternativesData = alternativesData.filter(Boolean);
      const alternativeCards = validAlternativesData.map((altData) => buildAlternativeCard(altData, searchType));

      if (!alternativeCards.length) throw Error('No alternatives were found');

      showResults(alternativeCards);

      window.dataLayer.push({
        event: 'oos_recommendations_results_rendered',
        source: 'oos_recommendations',
        data: {
          product_id: data.product.id,
          selected_variant_id: config.selectedVariant?.id,
          results: validAlternativesData.map((altData) => ({
            id: altData.id,
            title: altData.title,
            available: altData.available,
          })),
        }
      });
    }

    async function findAlternatives(searchType) {
      try {
        if (resultsContainer) resultsContainer.innerHTML = `
          <div class="sbs-alternatives__spinner"></div>
        `;

        let alternatives = [];

        if (searchType === searchTypes.VARIANT) {
          const savedAlternativesConfig = data.saved_variant_alternatives?.find((sac) => sac.variant_id === config.selectedVariant?.id); 
          const savedAlternativesList = savedAlternativesConfig?.list;
          const savedAlternativesExpiration = Number(savedAlternativesConfig?.date ? savedAlternativesConfig.date * 1000 : Date.now()) + (1000 * 60 * 60 * 4);
          const savedAlternatives = savedAlternativesList?.length && savedAlternativesExpiration > Date.now() ? savedAlternativesList : null;
          alternatives = savedAlternatives || config.cachedAlternatives?.[config.selectedVariant.id] || [];
        } else {
          const savedAlternativesList = data.saved_alternatives.list;
          const savedAlternativesExpiration = Number(data.saved_alternatives.date ? data.saved_alternatives.date * 1000 : Date.now()) + (1000 * 60 * 60 * 4);
          const savedAlternatives = savedAlternativesList?.length && savedAlternativesExpiration > Date.now() ? savedAlternativesList : null;
          alternatives = savedAlternatives || config.cachedAlternatives?.[data.product.id] || [];
        }
        
        if (!alternatives.length) {
          const { id, title, description, handle, vendor, type, tags } = data.product;
          let body = {
            n8nUrl: data.n8n_endpoint,
            productId: id.toString(),
            title,
            handle,
            description,
            tags,
            vendor,
            type,
            mcpStore: `https://${data.store}/api/mcp`,
          };

          if (searchType === searchTypes.VARIANT) {
            body = {
              ...body,
              variantId: config.selectedVariant.id.toString(),
              variantPrice: config.selectedVariant.price.toString(),
              variantOptions: config.selectedVariant.options.map((option, idx) => ({
                name: data.product.options[idx],
                value: option,
              })),
            }
          };

          if (data.n8n_endpoint && !data.show_hardcoded_results) {
            const response = await fetch('/tools/alternatives/recommendations', {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "shopify-key": "yWExfDSbUlK6ymAfFfHDqAy3uLb3vpPK9991234",
              },
              body: JSON.stringify(body),
            });
  
            if (response.status === 200) {
              const responseData = await response.json();
              alternatives = responseData?.products?.map(product => product.handle) || [];
            }
          } else {
            alternatives = await new Promise((resolve)=>{
              setTimeout(() => {
                  resolve([
                      "salty-crew-apex-flexfit-6-panel",
                      "mens-roamer-t-shirt",
                      "columbia-mens-csc-basic-logo™-tee",
                      "columbia-mens-columbia-tech™-spacer-knit-trousers",
                  ])
              }, 500);
            });
          }
        }

        if (!alternatives.length) throw Error();

        config.cachedAlternatives[searchType === searchTypes.VARIANT ? config.selectedVariant.id : data.product.id] = alternatives;
        await showAlternatives(alternatives, searchType);

        return {
          success: true,
        };
      } catch (error) {
        console.error("Find alternatives error: ", error);
        if (resultsContainer) resultsContainer.innerText = '';
        return {
          success: false,
        };
      }
    }

    function renderCTA(selectedVariantTitle) {
      block.innerHTML = `
        <div
          class="sbs-alternatives__cta"
          style="
            --sbs-btn-bg: ${data.styles.btn_bg};
            --sbs-btn-fg: ${data.styles.btn_fg};
            --sbs-btn-border-color: ${data.styles.btn_border_color};
            --sbs-btn-padding-block: ${data.styles.btn_padding_block};
            --sbs-btn-padding-inline: ${data.styles.btn_padding_inline};
            --sbs-btn-border-radius: ${data.styles.btn_border_radius};
          "
        >
          ${selectedVariantTitle || data.product.variants.length === 1 ? `
            <div class="sbs-alternatives__cta-variant">
              <span class="sbs-alternatives__cta-button">${strings.SIMILAR_NEUTRAL}</span>
            </div>
          ` : ''}
        </div>
      `;

      const ctaButton = block.querySelector(".sbs-alternatives__cta-button");

      ctaButton.addEventListener("click", async () => {
        window.dataLayer.push({
          event: 'oos_recommendations_button_clicked',
          source: 'oos_recommendations',
          data: {
            product_id: data.product.id,
            selected_variant_id: config.selectedVariant?.id
          }
        });
        ctaButton.innerText = strings.SIMILAR_FINDING;
        ctaButton.toggleAttribute('data-disabled', true);
        ctaButton.toggleAttribute('data-loading', true);
        const result = await findAlternatives(data.product.variants.length > 1 ? searchTypes.VARIANT : searchTypes.GENERAL);
  
        ctaButton.innerText = result.success
          ? strings.SIMILAR_NEUTRAL
          : strings.SIMILAR_FAILED;
        ctaButton.toggleAttribute('data-loading', false);
        if (!result.success) {
          setTimeout(() => {
            ctaButton.innerText = strings.SIMILAR_NEUTRAL;
            ctaButton.toggleAttribute('data-disabled', false);
          }, 1000);
        } else {
          ctaButton.toggleAttribute('data-disabled', false);
        }
      });

      if (config.showAutomatically && selectedVariantTitle) {
        ctaButtons[0].self?.click();
      } else {
        config.showAutomatically = true;
      }

      window.dataLayer.push({
        event: 'oos_recommendations_button_rendered',
        source: 'oos_recommendations',
        data: {
          product_id: data.product.id,
          selected_variant_id: config.selectedVariant?.id
        }
      });
    }

    function handleVariantChange(selectedVariantId) {
      config.selectedVariant = data.product.variants.find(
        (variant) => variant.id == selectedVariantId,
      );
      block.innerText = "";
      if (config.selectedVariant && !config.selectedVariant.available) {
        renderCTA(config.selectedVariant.title);
      } else if (!data.product.available) {
        renderCTA();
      }
    }

    function watchVariantChange() {
      setInterval(() => {
        const productForm =
          block.closest('[action="/cart/add"]') ||
          document.querySelector('[action="/cart/add"]');
        let selectedVariantId = null;
        if (productForm) {
          selectedVariantId = productForm.querySelector('[name="id"]')?.value;
        } else {
          selectedVariantId = data?.product?.variants[0]?.id;
        }

        if (
          !(
            selectedVariantId &&
            selectedVariantId != config.selectedVariant?.id
          )
        ) return;

        handleVariantChange(selectedVariantId);
      }, 250);
    }

    function formatMoney(amount) {
      const samplePriceFormat = data.samplePriceFormat;
      const dotDecimal = samplePriceFormat.includes('1,000');
      const showTrailingZeros = samplePriceFormat.includes(dotDecimal ? '1,000.00' : '1.000,00');

      const template = samplePriceFormat.replace(
        dotDecimal ? `1,000${showTrailingZeros ? '.00' : ''}`
        : `1.000${showTrailingZeros ? ',00' : ''}`,
        '[[amount]]'
      );

      const whole = Math.floor(amount / 100);
      const decimal = amount % 100;

      const wholeDelimiter = dotDecimal ? ',' : '.';
      const decimalSeparator = dotDecimal ? '.' : ',';

      const wholeFormatted = whole.toString().split('').reverse().map((d,i) => i > 3 && i % 3 === 1 ? `${wholeDelimiter}${d}` : d).reverse().join('');
      const formattedAmount = `${wholeFormatted}${decimal > 0 || showTrailingZeros ? `${decimalSeparator}${decimal < 10 ? `0${decimal}` : decimal}` : ''}`;

      return template.replace('[[amount]]', formattedAmount);
    }

    function initSlider(parent) {
      const slider = parent.querySelector('.sbs-slider');
      if (!slider) return;
      const slidesContainer = slider.querySelector('.sbs-slider__slides');
      const slides = Array.from(slider.querySelectorAll('.sbs-slider__slide'));
      const prevBtn = slider.querySelector('.sbs-slider__navigation-btn--prev');
      const nextBtn = slider.querySelector('.sbs-slider__navigation-btn--next');

      toggleNavigation();

      [prevBtn, nextBtn].forEach(btn => {
        btn.addEventListener('click', () => {
          const slideWidth = slides[0].offsetWidth;
          slidesContainer.scrollBy({left: (slideWidth + 12) * (btn === prevBtn ? -1 : 1), behavior: "smooth"});
        })
      });

      slidesContainer.addEventListener('scrollend', toggleNavigation);

      window.addEventListener('resize', adjustPositions);

      function adjustPositions () {
        if (!document.contains(parent)) {
          window.removeEventListener('resize', adjustPositions);
        }

        const slideWidth = slides[0].offsetWidth;
        const scrolledSlides = Math.floor((slidesContainer.scrollLeft + 12) / (slideWidth + 12));
        const scrollableWidth = scrolledSlides * (slideWidth + 12) - 12;
        slidesContainer.scrollTo({left: scrollableWidth});

        toggleNavigation();
      }

      function toggleNavigation () {
        if (!document.contains(parent)) {
          window.removeEventListener('resize', toggleNavigation);
          return
        }

        const allVisible = slidesContainer.scrollWidth === slidesContainer.clientWidth;
        prevBtn.setAttribute('data-visible', !(allVisible || slidesContainer.scrollLeft === 0));
        nextBtn.setAttribute('data-visible', !(allVisible || Math.abs(slidesContainer.scrollWidth - (slidesContainer.clientWidth + slidesContainer.scrollLeft)) < 10));
      }
    }
  }
})();
